const PT_MM_RATIO = 0.352778;
const pt2mm = (pt: number) => pt * PT_MM_RATIO;
export default pt2mm;
